export const formatValueWithPrecision = (
  num: number | string,
  precision = 2,
  local = 'en-US',
): string =>
  new Intl.NumberFormat(local, {
    useGrouping: true,
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  })
    .format(+num)
    .replace(/,/g, ' ');
